import React from 'react'
import classNames from 'classnames'
import { Trans } from 'react-i18next'
import type { Nullable } from '../../../shared/lib/typeHelpers.no-deps'
import type { CreditBalance } from '../../../shared/domain/credits/types.no-deps'
import { isCreditBalanceVeryLow } from '../../../shared/domain/credits/helpers.no-deps'
import { isNil } from '../../../shared/lib/functional/nil.no-deps'

type CreditBalanceTextProps = {
    creditBalance: Nullable<CreditBalance>
    creditsCost?: number
    hideIcon?: boolean
    i18nKey?: string
    testId?: string
}

export function CreditBalanceText({
    creditBalance,
    creditsCost,
    hideIcon = false,
    i18nKey,
    testId,
}: CreditBalanceTextProps) {
    const isLoading = isNil(creditBalance)

    return (
        <div
            className={classNames('AppCore__ui__CreditBalanceText_balance', {
                'AppCore__ui__CreditBalanceText_balance--very-low': isCreditBalanceVeryLow(creditBalance, creditsCost),
            })}
            {...(testId && { 'data-testid': testId })}
        >
            {!hideIcon && (
                <span className="AppCore__ui__CreditBalanceText_balanceIcon">
                    <zaptic-icon icon-name="star-token"></zaptic-icon>
                </span>
            )}
            <Trans i18nKey={i18nKey}>
                <span
                    className={classNames('AppCore__ui__CreditBalanceText__creditsCount', {
                        'AppCore__ui__CreditBalanceText__creditsCount--loading': isLoading,
                    })}
                    {...(creditBalance && {
                        'data-credits': creditBalance.totalBalance,
                        'data-testid': 'credit-balance-count',
                    })}
                >
                    {{
                        credits: isLoading
                            ? // Placeholder for the skeleton loader to take the width needed to render '100'. The
                              // more digits it has, the wider the skeleton loader will be.
                              100
                            : creditBalance.totalBalance,
                    }}
                </span>
            </Trans>
        </div>
    )
}
